import { Button } from "@/components/ui/button";
import { Calendar, MessageCircle } from "lucide-react";
import { Link } from "@tanstack/react-router";

const BlogCTA = () => {
  return (
    <div className="mt-10 sm:mt-12 rounded-2xl bg-primary/5 border border-primary/10 p-5 sm:p-10 text-center space-y-3 sm:space-y-4">
      <h3 className="text-lg sm:text-2xl font-typewriter font-bold text-foreground leading-snug">
        Quer cuidar da sua alimentação com acompanhamento profissional?
      </h3>
      <p className="text-sm sm:text-base text-muted-foreground font-sans leading-relaxed max-w-xl mx-auto">
        Atendimento em português, presencial em Brisbane ou online em toda a Austrália. Na primeira consulta, entendo seus objetivos e explico como posso ajudar.
      </p>
      <div className="flex flex-col sm:flex-row gap-2.5 sm:gap-3 justify-center pt-1 sm:pt-2">
        <Button
          size="lg"
          asChild
          className="rounded-full text-base px-6 py-5 w-full sm:w-auto"
          style={{ background: 'var(--gradient-green)' }}
        >
          <Link to="/consulta-inicial-gratuita">
            <Calendar className="mr-2 h-5 w-5" />
            Agendar consulta
          </Link>
        </Button>
        <Button
          size="lg"
          variant="outline"
          className="rounded-full text-base px-6 py-5 w-full sm:w-auto"
          onClick={() => window.open('https://wa.me/61423038977', '_blank')}
        >
          <MessageCircle className="mr-2 h-5 w-5" />
          Falar no WhatsApp
        </Button>
      </div>
    </div>
  );
};

export default BlogCTA;
